import { render, staticRenderFns } from "./cms-page-html.vue?vue&type=template&id=65c9e4a7&scoped=true"
import script from "./cms-page-html.vue?vue&type=script&lang=js"
export * from "./cms-page-html.vue?vue&type=script&lang=js"
import style0 from "./cms-page-html.vue?vue&type=style&index=0&id=65c9e4a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c9e4a7",
  null
  
)

export default component.exports